import { createDestinationLanding } from '@/router/destinationRoute';
import { useCompanySettingsAccess } from '@/abilities/companySettings/useCompanySettingsAccess';
import { companySettingsDestinationTree } from '@/abilities/companySettings/vocabulary';
import { companySettingsDestinationRoutes } from '@/pages/configurations/company/destinationRoutes';

export const { landingPath: companySettingsLandingPath, landing: companySettingsLanding } = createDestinationLanding(
  companySettingsDestinationTree,
  companySettingsDestinationRoutes,
  useCompanySettingsAccess,
);
